import * as React from "react";
import {
  Box,
  Flex,
  Spacer,
  Stack,
  Text,
  VStack,
  Center,
  Image,
  IconButton,
  AlertDialog,
  AlertDialogBody,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogContent,
  AlertDialogOverlay,
  Button,
  useDisclosure,
  Divider,
  Table,
  Thead,
  Tbody,
  Tfoot,
  Tr,
  Th,
  Td,
  TableCaption,
} from "@chakra-ui/react";
import { useTranslation } from "react-i18next";
import { EditIcon, DeleteIcon } from "@chakra-ui/icons";
import image1 from "../../assets/images/body.png";
import { Evaluation } from "../../types";
import { useCallback, useEffect, useState } from "react";
import { isMobile } from "react-device-detect";
import { useStores } from "../../hooks/useStores";

type Props = {
  dateOnTop: boolean;
  evaluation: Evaluation;
  onDelete: () => void;
  onEdit: () => void;
  prevEvaluationIndex: number;
  isSubscriptionDeactivated?: boolean;
};

const printableNumber = function (n) {
  return n > 0 ? "+" + n : n;
};

export const EvaluationCard: React.FC<Props> = ({
  dateOnTop,
  evaluation,
  onEdit,
  onDelete,
  prevEvaluationIndex,
  isSubscriptionDeactivated = false,
}) => {
  const { clientsStore } = useStores();
  const { t } = useTranslation();
  const { isOpen, onOpen, onClose } = useDisclosure();
  const cancelRef = React.useRef<HTMLButtonElement>(null);
  const [day, setDay] = useState<any>();
  const [month, setMonth] = useState<any>();
  const [year, setYear] = useState<any>();
  const [prevEvaluation, setPrevEvaluation] = useState<Evaluation | null>();

  const setData = useCallback(() => {
    const monthNames = [
      "Jan",
      "Feb",
      "March",
      "April",
      "May",
      "June",
      "July",
      "Aug",
      "Sept",
      "Oct",
      "Nov",
      "Dec",
    ];

    var d = new Date(evaluation.data);
    setDay(d.getDate());
    setMonth(monthNames[d.getMonth()]);
    setYear(d.getFullYear());
  }, [evaluation.data]);

  const getPrevEvaluation = useCallback(() => {
    if (clientsStore.evaluation[prevEvaluationIndex]) {
      setPrevEvaluation(clientsStore.evaluation[prevEvaluationIndex]);
    } else {
      setPrevEvaluation(null);
    }
  }, [clientsStore.evaluation, prevEvaluationIndex]);

  useEffect(() => {
    setData();
    getPrevEvaluation();
  }, [getPrevEvaluation, setData]);

  return (
    <>
      <Flex color="white" flexDirection="column">
        {(dateOnTop || isMobile) && (
          <Flex color="black" mb="10px" mt="30px">
            <Spacer />
            <Text mr="30px">{day + "  " + month + ".  '" + year}</Text>
          </Flex>
        )}

        <Flex color="white">
          {!dateOnTop && !isMobile && (
            <VStack spacing={0} align="stretch" mr="5px">
              <Center>
                <Text fontSize="48px" color="black">
                  {day}
                </Text>
              </Center>

              <Center>
                <Text fontSize="12px" color="black">
                  {month + ".  '" + year}
                </Text>
              </Center>
            </VStack>
          )}
          <Flex
            w={dateOnTop ? "92%" : "82%"}
            border="1px"
            borderColor="#EBF3F8"
            borderRadius="16px"
            flexDirection="column"
            p="20px"
            bg="white"
            boxShadow=" 0px 0px 20px rgba(51, 102, 255, 0.15)"
          >
            <Flex
              w="100%"
              // h="330px"
              flex="1"
              flexDirection={isMobile ? "column-reverse" : "row"}
            >
              <Center
                // w="30%"
                w={isMobile ? "100%" : "30%"}
                flexDirection="column"
                //   pl="30px"
                //   pr="30px"
              >
                {evaluation?.photo_url && (
                  <Image
                    h="329px"
                    // boxSize="100%"
                    borderRadius="16px"
                    objectFit="cover"
                    src={evaluation.photo_url}
                    alt=""
                  />
                )}
              </Center>
              <Flex
                // w="70%"

                w={isMobile ? "100%" : "70%"}
                flexDirection="column"
              >
                <Center flexDirection="column">
                  <Stack flex="1" my="20px" mx="20px">
                    <Table variant="striped" size="sm" colorScheme="black">
                      <Thead>
                        <Tr>
                          <Th></Th>
                          <Th>Obiettivo</Th>
                          <Th>Misure attuali</Th>
                          <Th>Misure precedenti</Th>
                          <Th>Miglioramento</Th>
                        </Tr>
                      </Thead>
                      <Tbody>
                        <Tr style={{ color: "black" }}>
                          <Td>Peso (kg)</Td>
                          <Td isNumeric>
                            {evaluation.personalObjective.weight}
                          </Td>
                          <Td isNumeric>{evaluation.weight}</Td>
                          <Td isNumeric>
                            {prevEvaluation?.weight
                              ? prevEvaluation?.weight
                              : "-"}
                          </Td>
                          <Td isNumeric>
                            {prevEvaluation && prevEvaluation.weight !== null
                              ? printableNumber(
                                  parseFloat(evaluation.weight) -
                                    parseFloat(prevEvaluation.weight)
                                ) + " kg"
                              : "-"}
                          </Td>
                        </Tr>
                        <Tr style={{ color: "black" }}>
                          <Td>Massa grassa (%)</Td>
                          <Td isNumeric>
                            {evaluation.personalObjective.lean_mass}
                          </Td>
                          <Td isNumeric>{evaluation.lean_mass}</Td>
                          <Td isNumeric>
                            {prevEvaluation?.lean_mass
                              ? prevEvaluation?.lean_mass
                              : "-"}
                          </Td>
                          <Td isNumeric>
                            {prevEvaluation && prevEvaluation.lean_mass !== null
                              ? printableNumber(
                                  parseFloat(evaluation.lean_mass) -
                                    parseFloat(prevEvaluation.lean_mass)
                                ) + " %"
                              : "-"}
                          </Td>
                        </Tr>
                        <Tr style={{ color: "black" }}>
                          <Td>Seno (cm)</Td>
                          <Td isNumeric>
                            {evaluation.personalObjective.breast}
                          </Td>
                          <Td isNumeric>{evaluation.breast}</Td>
                          <Td isNumeric>
                            {prevEvaluation?.breast
                              ? prevEvaluation?.breast
                              : "-"}
                          </Td>
                          <Td isNumeric>
                            {prevEvaluation && prevEvaluation.breast !== null
                              ? printableNumber(
                                  parseFloat(evaluation.breast) -
                                    parseFloat(prevEvaluation.breast)
                                ) + " cm"
                              : "-"}
                          </Td>
                        </Tr>
                        <Tr style={{ color: "black" }}>
                          <Td>Vita (cm)</Td>
                          <Td isNumeric>
                            {evaluation.personalObjective.waist}
                          </Td>
                          <Td isNumeric>{evaluation.waist}</Td>
                          <Td isNumeric>
                            {prevEvaluation?.waist
                              ? prevEvaluation?.waist
                              : "-"}
                          </Td>
                          <Td isNumeric>
                            {prevEvaluation && prevEvaluation.waist !== null
                              ? printableNumber(
                                  parseFloat(evaluation.waist) -
                                    parseFloat(prevEvaluation.waist)
                                ) + " cm"
                              : "-"}
                          </Td>
                        </Tr>
                        <Tr style={{ color: "black" }}>
                          <Td>Coscia (cm)</Td>
                          <Td isNumeric>
                            {evaluation.personalObjective.thigh}
                          </Td>
                          <Td isNumeric>{evaluation.thigh}</Td>
                          <Td isNumeric>
                            {prevEvaluation?.thigh
                              ? prevEvaluation?.thigh
                              : "-"}
                          </Td>
                          <Td isNumeric>
                            {prevEvaluation && prevEvaluation.thigh !== null
                              ? printableNumber(
                                  parseFloat(evaluation.thigh) -
                                    parseFloat(prevEvaluation.thigh)
                                ) + " cm"
                              : "-"}
                          </Td>
                        </Tr>
                      </Tbody>
                    </Table>
                  </Stack>
                </Center>
              </Flex>
            </Flex>
            {evaluation.objectives.map((objective) => {
              var color = "#FF3333";
              if (objective.valutation == 1) {
                color = "#FF3333";
              } else if (objective.valutation == 2) {
                color = "#FF9933";
              } else if (objective.valutation == 3) {
                color = "#FFA500";
              } else if (objective.valutation == 4) {
                color = "#FFFF33";
              } else if (objective.valutation == 5) {
                color = "#80FF00";
              }

              return (
                <Flex
                  flex="1"
                  flexDirection="column"
                  border="1.5px solid #942d9c"
                  borderRadius="10px"
                  p="7px"
                  mt="30px"
                >
                  <Flex flex="1" flexDirection="row" alignItems="self-start">
                    <Box flex="1">
                      <Text fontSize="md" color="black" fontWeight="600">
                        {objective.objective.title}
                      </Text>
                    </Box>
                    <Box
                      bgColor={color}
                      pt="2px"
                      pb="2px"
                      pl="7px"
                      pr="7px"
                      borderRadius="4px"
                    >
                      <Text fontSize="md" color="black" fontWeight="600">
                        {objective.valutation}
                      </Text>
                    </Box>
                  </Flex>
                  <Flex flex="1" flexDirection="row">
                    <Text fontSize="md" color="#4A5568">
                      {objective.objective.description}
                    </Text>
                  </Flex>
                  <Divider size={"lg"} mb="15px" mt="15px" />
                  <Flex flex="1" flexDirection="row" bg="">
                    <Text fontSize="md" color="#4A5568">
                      {objective.comment}
                    </Text>
                  </Flex>
                </Flex>
              );
            })}
          </Flex>
          <Flex w="8%" flex="1" flexDirection="column" my={"20px"}>
            <IconButton
              w={8}
              h={8}
              p={1}
              mx={"auto"}
              my={"10px"}
              color="black"
              aria-label="Search database"
              variant="ghost"
              colorScheme="black"
              fontSize="20px"
              icon={<EditIcon />}
              onClick={onEdit}
              disabled={isSubscriptionDeactivated}
            />

            <IconButton
              w={8}
              h={8}
              p={1}
              mx={"auto"}
              my={"10px"}
              aria-label="Search database"
              variant="ghost"
              color="black"
              fontSize="20px"
              icon={<DeleteIcon />}
              onClick={() => onOpen()}
              disabled={isSubscriptionDeactivated}
            />
          </Flex>
        </Flex>
      </Flex>

      <AlertDialog
        motionPreset="slideInBottom"
        leastDestructiveRef={cancelRef}
        onClose={onClose}
        isOpen={isOpen}
        isCentered
      >
        <AlertDialogOverlay>
          <AlertDialogContent>
            <AlertDialogHeader fontSize="lg" fontWeight="bold">
              {t("screens.client.evaluationAccordionDelete.title")}
            </AlertDialogHeader>

            <AlertDialogBody>
              {t("screens.client.evaluationAccordionDelete.dialog")}
            </AlertDialogBody>

            <AlertDialogFooter>
              <Button ref={cancelRef} onClick={onClose}>
                {t("common.cancel")}
              </Button>
              <Button
                colorScheme="red"
                onClick={() => {
                  onDelete();
                  onClose();
                }}
                ml={3}
              >
                {t("common.confirm")}
              </Button>
            </AlertDialogFooter>
          </AlertDialogContent>
        </AlertDialogOverlay>
      </AlertDialog>
    </>
  );
};
